import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons'
import { Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

import AtomFormInput from '@/components/Atoms/AtomFormInput/AtomFormInput'
import type { DeliveryAddressFormType } from '@/components/EntityCreationModals/DeliveryAddressCreationModal/DeliveryAddressCreationModal.config'
import type {
  DeliveryAddressInterface,
  FormInputControlType,
  FormInputRegisterType,
} from '@/types'

import cn from './DeliveryAddresses.module.scss'

type GetColumnsParams = {
  editingId: string
  control: Control<DeliveryAddressFormType>
  register: UseFormRegister<DeliveryAddressFormType>
  errors: FieldErrors<DeliveryAddressFormType>
  onEdit: (address: DeliveryAddressInterface) => void
  onSave: (id: string) => void
  onCancel: () => void
  onDelete: (id: string) => void
  isSelectedOrganisation: boolean
}

export const getColumns = ({
  editingId,
  control,
  register,
  errors,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  isSelectedOrganisation,
}: GetColumnsParams): ColumnsType<DeliveryAddressInterface> => [
  {
    title: 'Действия',
    key: 'actions',
    width: 100,
    render: (_: unknown, record: DeliveryAddressInterface) => (
      <div className={cn.actionsContainer}>
        {editingId === record.id ? (
          <>
            <div
              className={cn.saveIconContainer}
              onClick={() => onSave(record.id)}
            >
              <CheckOutlined title="Сохранить" />
            </div>
            <div className={cn.cancelIconContainer} onClick={onCancel}>
              <CloseCircleOutlined title="Отменить" />
            </div>
          </>
        ) : (
          <>
            <div
              className={cn.editIconContainer}
              onClick={() => onEdit(record)}
            >
              <EditOutlined title="Редактировать" />
            </div>
            <Popconfirm
              title="Удалить адрес доставки?"
              description="Это действие нельзя отменить"
              onConfirm={() => onDelete(record.id)}
              okText="Да"
              cancelText="Нет"
              okButtonProps={{
                className: isSelectedOrganisation
                  ? cn.confirmOkButtonSelected
                  : cn.confirmOkButton,
              }}
            >
              <div className={cn.deleteIconContainer}>
                <DeleteOutlined title="Удалить" />
              </div>
            </Popconfirm>
          </>
        )}
      </div>
    ),
  },
  {
    title: 'Адрес',
    dataIndex: 'address',
    key: 'address',
    render: (address: string, record: DeliveryAddressInterface) =>
      editingId === record.id ? (
        <AtomFormInput
          isOrganisationSelected={isSelectedOrganisation}
          location="deliveryAddressEdit"
          name="address"
          control={control as FormInputControlType}
          register={register as FormInputRegisterType}
          errors={errors}
          fullWidth
        />
      ) : (
        <span className={cn.address}>{address}</span>
      ),
  },
]
